// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-activity-ideation-tools{display:block;padding:15px;background-color:#fff;border-radius:4px;text-align:center}.task-activity-ideation-tools__title{margin-top:0;margin-bottom:20px}.task-activity-ideation-tools__stage-buttons{display:flex}.task-activity-ideation-tools__stage-buttons .btn{flex-grow:1}.task-activity-ideation-tools__stage-buttons .btn.disabled{opacity:1}", ""]);
// Exports
module.exports = exports;
